import Ajv from 'ajv';

export default new Ajv();
